<template>
  <div class="be-content" v-if="guestVisit">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-heading panel-heading-divider">Добавление записи о плательщике
            </div>
            <div class="panel-body">
              <guest-visit-form :guestVisit="guestVisit" ref="form" @dataIsValid="submitData"></guest-visit-form>
              <div class="col-ls-12 text-center">
                <button class="btn btn-space btn-success btn-lg" @click="validateDataForm">Создать</button>

                <button class="btn btn-space btn-danger btn-lg" @click="$router.go(-1)">Отмена
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DatePicker from 'vue2-datepicker'
  import axios from 'axios'
  import {mapActions} from 'vuex'
  import momment from 'moment'
  import GuestVisitForm from './GuestVisitForm'


  export default {
    components: {DatePicker, GuestVisitForm},
    props: [
      'operatorId'
    ],
    data: function () {
      return {
        guestVisit: {
          operator: null,
          last_name: null,
          first_name: null,
          middle_name: null,
          date_start: null,
          taxable_period: null,
          date_end: null,
          privilege_category: null,
          refusal_to_pay: false,
          tax_amount: null
        }
      }
    },
    created () {
      this.guestVisit.operator = this.operatorId
    },
    methods: {
      submitData () {
        let data = this.guestVisit
        data['date_start'] = moment(this.guestVisit.date_start, "DD.MM.YYYY").format('YYYY-MM-DD')
        data['date_end'] = moment(this.guestVisit.date_end, "DD.MM.YYYY").format('YYYY-MM-DD')
        data['operator'] = this.guestVisit.operator.id
        if (this.guestVisit.privilege_category) {
          data['privilege_category'] = this.guestVisit.privilege_category.id
        }
        axios.post('/api/guest_visits/', data)
          .then((response) => {
            if (response.status === 201) {
              this.$router.go(-1)
              this.$snotify.success('Запись добавлена.', 'Успешно!')
            }
          })
          .catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error(error.response.data.detail, 'Ошибка!', {timeout: 10000})
              this.$refs.form.updateFieldValue()
            }
          })
      },
      validateDataForm: function () {
        this.$refs.form.validate()
      }
    },
    ...mapActions([
      'setCurrentReport',
    ])
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/guests/GuestVisitAdd.vue